<template>
    <div class="d-flex align-items-center py-1 w-100 pagination-wrapper">

        <!-- LEFT : Page Size -->
        <div class="flex-grow-1 text-start" style="margin-right:10px">
            <div style="max-width:120px">
                <select class="form-select"
                        v-model="localPageSize"
                        @change="onPageSizeChange">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="400">400</option>
                    <option value="1000">1000</option>
                </select>
            </div>
        </div>

        <!-- CENTER : Pagination -->
        <div class="flex-grow-1 text-center" style="margin-top:10px">
            <nav aria-label="Page navigation">
                <ul class="pagination justify-content-center mb-0">

                    <!-- Previous -->
                    <li class="page-item" :class="{ disabled: pageNo === 1 }">
                        <a class="page-link"
                           href="javascript:void(0)"
                           @click.prevent="goToPage(pageNo - 1)">
                            السابق
                        </a>
                    </li>

                    <!-- Pages -->
                    <li v-for="page in totalPages"
                        :key="page"
                        class="page-item"
                        :class="{ active: pageNo === page }">
                        <a class="page-link"
                           href="javascript:void(0)"
                           @click.prevent="goToPage(page)">
                            {{ page }}
                        </a>
                    </li>

                    <!-- Next -->
                    <li class="page-item" :class="{ disabled: pageNo === totalPages }">
                        <a class="page-link"
                           href="javascript:void(0)"
                           @click.prevent="goToPage(pageNo + 1)">
                            التالي
                        </a>
                    </li>

                </ul>
            </nav>
        </div>

        <!-- RIGHT : Info -->
        <div class="flex-grow-1 text-end" style="margin-left:10px">
            <p class="mb-0 fs-2">{{ infoText }}</p>
        </div>

    </div>
</template>


<script>
    export default {
        name: "PaginationHelper",
        props: {
            pageNo: {
                type: Number,
                required: true
            },
            pageSize: {
                type: Number,
                required: true
            },
            totalItems: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                localPageSize: this.pageSize
            };
        },
        computed: {
            totalPages() {
                return Math.ceil(this.totalItems / this.pageSize);
            },
            infoText() {
                if (!this.totalItems) return 'لا توجد سجلات';
                const from = (this.pageNo - 1) * this.pageSize + 1;
                const to = Math.min(this.pageNo * this.pageSize, this.totalItems);
                return 'عرض ' + from + '–' + to + ' من أصل ' + this.totalItems + ' سجل';
            }
        },
        watch: {
            pageSize(newVal) {
                this.localPageSize = newVal;
            }
        },
        methods: {
            goToPage(page) {
                if (page >= 1 && page <= this.totalPages && page !== this.pageNo) {
                    this.$emit("page-changed", page);
                }
            },
            onPageSizeChange() {
                this.$emit("page-size-changed", this.localPageSize);
            }
        }
    };


</script>

<style scoped>
    .pagination-wrapper {
        gap: 10px;
    }

    .pagination .disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .pagination .active .page-link {
        font-weight: bold;
    }
</style>